import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { Router } from '@angular/router'; // ✅ Use Router, not ActivatedRoute
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export enum SuccessType {
  DELETE_DOCUMENT = 'delete_document',
  DOWNLOAD_DOCUMENT = 'download_document',
  UPDATE_DOCUMENT_INFO = 'update_document_info',
  UPDATE_DOCUMENT_TAGS = 'update_document_tags',
  DELETE_TEAM_MEMBER = 'delete_team_member',
  DELETE_LEAD = 'delete_lead',
  DELETE_QUERY = 'delete_query',
  RESET_PASSWORD = 'reset_password'
}

@Component({
    selector: 'appdoc-success-message',
    templateUrl: './success-message.component.html',
    styleUrls: ['./success-message.component.css'],
    standalone: false
})
export class SuccessDocMessageComponent {
  // @Input() message: string = 'Operation completed successfully.';
  @Output() close = new EventEmitter<void>();
  uid:any;
  @Input() successType!: SuccessType;
  @Input() data: any; // For dynamic data like document name
  @Input() message: string = ''; // Custom message

  constructor(
   private httpService:HttpService,public activeModal: NgbActiveModal,
    private route: ActivatedRoute, private router: Router
  ) {}
  
  closeMessage() {
    this.activeModal.close();
    // const baseUrl = window.location.origin; // will give you current origin like http://localhost:54382
    // const c = localStorage.getItem('enquiryid');
    // const link = `${baseUrl}/document-upload?enquiryid=${c}`;
    // console.log('Navigating to:', link);
    // window.location.href = link;
  }
      get successMessage(): string {
    if (this.message) {
      return this.message;
    }
    
    switch (this.successType) {
      case SuccessType.DELETE_DOCUMENT:
        return `Congratulations!! You have successfully deleted the document ${this.data?.name || ''}`;
      case SuccessType.DOWNLOAD_DOCUMENT:
        return `Congratulations!! You have successfully downloaded the document ${this.data?.name || ''}`;
      case SuccessType.UPDATE_DOCUMENT_INFO:
        return `Congratulations!! You have successfully updated the document information.`;
      case SuccessType.UPDATE_DOCUMENT_TAGS:
        return `Congratulations!! You have successfully updated the document tags.`;
      case SuccessType.DELETE_TEAM_MEMBER:
        return `Congratulations!! You have successfully deleted the team member.`;
      case SuccessType.DELETE_LEAD:
        return `Congratulations!! You have successfully deleted the lead.`;
      case SuccessType.DELETE_QUERY:
        return `Congratulations!! You have successfully deleted the query.`;
      case SuccessType.RESET_PASSWORD:
        return `Congratulations!! You have successfully initiated password reset.`;
      default:
        return 'Operation completed successfully!';
    }
  }
}
